import { Fragment, useCallback, useState } from 'react';
import arrowLeft from '~/assets/icons/arrow_left_2.svg';
import calendar from '~/assets/icons/calendar.svg';
import camera from '~/assets/icons/camera.svg';
import cross from '~/assets/icons/cross.svg';
import plusRound from '~/assets/icons/plus_round.svg';
import { CollectionImage, CurrencyIcon } from '~/components/collections';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import photoExample from '../../assets/images/photo_example.jpg';
import {
	setCreateVisible,
	setDoneVisible,
	setItemSelectVisible,
	useLayoutDispatch,
} from '../../redux';
import { MoneyInput } from '../MoneyInput';
import { Select } from '../Select';
import { TextLabel } from '../TextLabel';
import { timeSelectItems } from './AppAdsCreate.model';
import {
	StyledActivePhotoContainer,
	StyledAddPhoto,
	StyledBackButton,
	StyledContainer,
	StyledCrossButton,
	StyledHeadContainer,
	StyledMainContainer,
	StyledPhoto,
	StyledPhotoList,
	StyledPriceSettingsContainer,
	StyledPublishButton,
	StyledRemovePhoto,
	StyledTextAreaContainer,
	StyledTimeContainer,
	StyledTimePriceContainer,
} from './AppAdsCreate.styled';

const AppAdsCreate = () => {
	const dispatch = useLayoutDispatch();
	const [textAreaValue, setTextAreaValue] = useState('');
	const [price, setPrice] = useState(0);
	const [timeValue, setTimeValue] = useState(1);

	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const handlePublish = useCallback(() => {
		if (!price) {
			return;
		}

		dispatch(setCreateVisible(false));
		dispatch(setDoneVisible(true));
	}, [price]);

	return (
		<StyledContainer>
			<StyledHeadContainer>
				<StyledBackButton
					onClick={() => {
						dispatch(setCreateVisible(false));
						dispatch(setItemSelectVisible(true));
					}}
				>
					<img src={arrowLeft} />
					<TextLabel>Вернуться назад</TextLabel>
				</StyledBackButton>
				<TextLabel
					style={{
						fontSize: 14,
						color: '#ffffff',
						opacity: 0.5,
						textAlign: 'center',
					}}
				>
					Mercedes E63s AMG (Отчёт №778)
				</TextLabel>
				<StyledCrossButton onClick={() => dispatch(setCreateVisible(false))}>
					<img src={cross} />
				</StyledCrossButton>
			</StyledHeadContainer>
			<StyledMainContainer>
				<StyledActivePhotoContainer>
					<CollectionImage collection={'vehicles'} size={156} id={'gaz_2410'} />
				</StyledActivePhotoContainer>
				<StyledPhotoList>
					<StyledPhoto>
						<img src={photoExample} />
						<StyledRemovePhoto />
					</StyledPhoto>
					<StyledPhoto>
						<img src={photoExample} />
						<StyledRemovePhoto />
					</StyledPhoto>
					<StyledAddPhoto>
						<img src={camera} />
						<TextLabel>Добавить фото</TextLabel>
					</StyledAddPhoto>
				</StyledPhotoList>
				<StyledTextAreaContainer>
					<textarea
						maxLength={200}
						rows={4}
						placeholder={'Придумайте описание товара...'}
						value={textAreaValue}
						onChange={(e) => setTextAreaValue(e.target.value)}
					></textarea>
					<div className={'bottom'}>
						<TextLabel>После публикации изменить описание нельзя</TextLabel>
						<TextLabel>{`${textAreaValue.length} / 200`}</TextLabel>
					</div>
				</StyledTextAreaContainer>
				<StyledPriceSettingsContainer>
					<StyledTimeContainer>
						<Select
							value={timeValue}
							items={timeSelectItems}
							placeholder={''}
							onChange={(value) => setTimeValue(value.value as number)}
							icon={calendar}
						/>
						<StyledTimePriceContainer>
							<TextLabel>
								{(timeValue * 1000).toLocaleString('ru-RU')}
							</TextLabel>
							<CurrencyIcon icon={rubleIcon} size="sm" />
						</StyledTimePriceContainer>
					</StyledTimeContainer>
					<MoneyInput
						value={price}
						placeholder={'Введите стоимость'}
						onChange={setPrice}
					/>
				</StyledPriceSettingsContainer>
				<StyledPublishButton $disabled={!price} onClick={handlePublish}>
					{price ? (
						<Fragment>
							<img src={plusRound} />
							<TextLabel>Опубликовать объявление</TextLabel>
						</Fragment>
					) : (
						<TextLabel>Введите стоимость товара</TextLabel>
					)}
				</StyledPublishButton>
			</StyledMainContainer>
		</StyledContainer>
	);
};

export { AppAdsCreate };
